// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { harmonyOne as _harmonyOne } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the harmonyOne chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 1666600000
 * Chain Name: Harmony One
 * Default Block Explorer: https://explorer.harmony.one
 * Default RPC URL: https://rpc.ankr.com/harmony
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { harmonyOne } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: harmonyOne,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const harmonyOne = createCommon({
	..._harmonyOne,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
